import { render, staticRenderFns } from "./dataInfoDetail.vue?vue&type=template&id=f95b6934&scoped=true"
import script from "./dataInfoDetail.vue?vue&type=script&lang=js"
export * from "./dataInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./dataInfoDetail.vue?vue&type=style&index=0&id=f95b6934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b6934",
  null
  
)

export default component.exports